import React from 'react'

import styles from './tooltip.module.css'

const Tooltip = ({ children }) => {
  return (
    <div className={styles.tooltipTrigger}>
      ?
      <span className={styles.tooltipContainer}>{children}</span>
    </div>
  )
}

export default Tooltip
